import { Field, Model } from 'serialize-ts';

@Model()
export class BlackDeal {
  @Field()
  totalCount: number;
}
